<div class="sms-header">
  <span class="sms-count">{{ 'components.siteMultiSelect.selectedCount' | translate: { count: selectedIds.size } }}</span>
  <div class="sms-bulk-actions">
    <button type="button" (click)="selectAll()">{{ 'components.siteMultiSelect.selectAll' | translate }}</button>
    <span class="sms-bulk-sep">·</span>
    <button type="button" (click)="deselectAll()">{{ 'components.siteMultiSelect.deselectAll' | translate }}</button>
  </div>
</div>

<div class="sms-search">
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
  <input type="text" [value]="search()" (input)="onSearchInput($any($event.target).value)"
         [placeholder]="'components.siteMultiSelect.searchPlaceholder' | translate">
</div>

<div class="sms-list">
  @for (site of filteredSites(); track site.id) {
    <label class="sms-row" [class.disabled]="site.disabled">
      <input type="checkbox" [checked]="isSelected(site.id)" [disabled]="site.disabled" (change)="toggle(site)">
      <span class="sms-name">{{ site.name }}</span>
      @if (site.disabled && site.disabledReason) {
        <span class="sms-reason">{{ site.disabledReason }}</span>
      }
    </label>
  } @empty {
    <div class="sms-empty">{{ 'components.siteMultiSelect.noResults' | translate }}</div>
  }
</div>
